export const trackUserSession = () => {
    let lastEngageTime = localStorage.getItem("lastEngageTime");
    if(lastEngageTime){
        const oldDate = new Date(lastEngageTime);
        const currentTime = new Date();
        let totalIdelTime =(currentTime.getTime() - oldDate.getTime()) / 1000;
        totalIdelTime /= 60;
        totalIdelTime = Math.abs(Math.round(totalIdelTime));
        if(totalIdelTime!=0){
        localStorage.setItem("lastEngageTime",currentTime);
        if(totalIdelTime>30){
            localStorage.removeItem("visited_pages");
            localStorage.removeItem("searchRefinements");
            localStorage.removeItem("searchExitData");
        }
        }
    }else{
        const currentTime = new Date();
        localStorage.setItem("lastEngageTime",currentTime);
        localStorage.removeItem("visited_pages");
        localStorage.removeItem("searchRefinements");
        localStorage.removeItem("searchExitData");
    }
  };